import './index.sass';
import Backbone from 'backbone/backbone-min';
import axios from 'axios';

export default () => {
  const initCitys = () => {
    $('.js-country').on('change', e => {
      initAxios($(e.currentTarget).val());
    })
  }

  const initAxios = (id) => {
    axios({
      method: 'GET',
      url: `/api/profile/${id}/cities`,
    }).then(response => {
      let $citySelector = $('.js-city');
      $citySelector.empty();
      response.data.forEach( city => {
        $citySelector.append($('<option>', { value : city.id }).text(city.name));
      })
    })
  }
  initCitys();

  $('.js-input-show').on('click', () => {
    $('.settings-form__input--edit').toggleClass('settings-form__input--show');
  })

  let TextAreaForm, settingsForm, textAreaForm;
  settingsForm = $('.js-setting-form');
  if (settingsForm.length) {
    TextAreaForm = Backbone.View.extend({
      el: settingsForm,
      events: {
        'input .textarea-default': 'checkTextAreaLimit',
        'click #avatar-delete': 'deleteAvatar'
      },
      initialize: function() {
        var self;
        this.checkTextAreaLimit();
        self = this;
        return $('#avatar-upload').fileupload({
          url: Routes.personal_settings_user_avatars_path(),
          type: 'POST',
          dataType: 'json',
          headers: {
            "X-CSRF-Token": $('meta[name=csrf-token]').attr('content'),
          },
          formData: [],
          done: function(e, data) {
            var response;
            response = data.result;
            if (response.error) {
              return showError(response.error);
            } else {
              self.avatarImage().html('<img src=' + response.avatar_url + '>');
              self.avatarImage().removeClass('default');
              self.deleteAvatarButton().removeClass('hidden');
              self.avatarCacheInput().val(response.avatar_cache);
              return self.removeAvatarInput().val(0);
            }
          },
          fail: function() {
            return showError(I18n.t('server_error'));
          }
        });
      },
      checkTextAreaLimit: function() {
        if($('.textarea-default').length) {
          if ($('.textarea-default').val().length >= 250) {
            $('.settings-form__count').addClass('settings-form__count--red');
          } else {
            $('.settings-form__count').removeClass('settings-form__count--red');
          }
          $('.settings-form__number').text($('.textarea-default').val().length);
          return true;
        }
      },
      deleteAvatar: function() {
        this.avatarCacheInput().val('');
        this.avatarImage().html(this.avatarImage().data('avatar'));
        this.avatarImage().addClass('default');
        this.deleteAvatarButton().hide();
        return this.removeAvatarInput().val(1);
      },
      avatarCacheInput: function() {
        return this.$el.find('#user_avatar_cache');
      },
      avatarImage: function() {
        return this.$el.find('.settings-form__avatar');
      },
      deleteAvatarButton: function() {
        return this.$el.find('#avatar-delete');
      },
      removeAvatarInput: function() {
        return this.$el.find('#user_remove_avatar');
      }
    });
    return textAreaForm = new TextAreaForm();

  }

  let forceDestroy;
  if ($('.js-system-form').length) {
    $('.js-system-form').find('.social-checkbox').find('input').change(function() {
      if ($(this).is(':checked')) {
        return window.location = $(this).data('url');
      } else {
        return $.ajax({
          url: Routes.authentication_path({
            id: $(this).data('id')
          }),
          method: 'POST',
          data: {
            _method: 'delete'
          }
        });
      }
    });
    forceDestroy = false;
    return $('#user-delete-btn').click(function() {
      var self;
      if (!forceDestroy) {
        self = $(this);
        showQuestion(I18n.t('you_really_want_destroy_your_account'), function() {
          forceDestroy = true;
          return self.trigger('click');
        });
        return false;
      } else {
        return true;
      }
    });
  }
  }
